import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({ endPoint: 'DocumentTypeUse/AllFleets', method: 'GET', body: null, token: token })
}
